import * as d3 from 'd3';
import { chartSm, chartXs } from '../../constants';

export function setSizeClasses(group: d3.Selection<any>, width: number, height: number, ratio: number = 1) {
    ratio = ratio || 1;
    const xs = width < (chartXs * ratio) || height < (chartXs * ratio);
    const sm = !xs && (width < chartSm * ratio || height < chartSm * ratio);
    group.classed('sm', sm)
        .classed('xs', xs);
}